// test779
(779 && 0);
